module.exports = __webpack_public_path__ + "media/images/ai_book-26f5b2fd.svg";